import { render, staticRenderFns } from "./BaseCalendarIconItem.vue?vue&type=template&id=44e3e2da&scoped=true&"
import script from "./BaseCalendarIconItem.vue?vue&type=script&lang=js&"
export * from "./BaseCalendarIconItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e3e2da",
  null
  
)

export default component.exports